import Apiaxios from '../api/endpoints.js'
import { OK, UNAUTHORIXED, INTERNAL_SERVER_ERROR } from '../util.js'

const state = {
  apiStatus: null,
  loginErrorMessages: null,
  netWorkErrorMessages: null,
  hasToken: null,
  user: null,
  mode: null,
  modules: null
}

const getters = {
  check: state => !! state.user,                              //!! ←二重否定
  super_user: state => {
    if(state.user){
      return state.user.permission.super_user ? state.user.permission.super_user : false
    }
    return false
  },
  admin_user: state => {
    if(state.user){
      return state.user.permission.admin ? state.user.permission.admin : false
    }
    return false
  },
  user: state => state.user ? state.user : '',
  username: state => state.user ? state.user.username : '',
  token: state => state.hasToken ? state.hasToken : '',
  postUser: state => { return {user: state.user, token: state.hasToken}},
}

const mutations = {
  setUser(state, data){
    state.user = data.user ? data.user : null
    state.hasToken = data.token ? data.token : null
    state.mode = data.mode ? data.mode : null
    state.modules = data.modules ? data.modules : null
  },
  setApiStatus(state, status){
    state.apiStatus = status
  },
  setLoginErrorMessages(state, messages){
    state.loginErrorMessages = messages
  },
  setLocation(state, location){
    state.user.location.lat = location.lat
    state.user.location.lng = location.lng
  },
  setMode(state, mode){
    state.mode = mode
  }
}

const actions = {
  /**
   * ログイン認証
   * @param {*} context
   * @param {*} data
   */
  async login (context, data){
    context.commit('setApiStatus', null)
    context.commit('loading/setLoadingStatus', { loading: true }, { root: true } )
    
    //ログインAPI
    await Apiaxios.login(data).then( response => {
      if(response.status === OK){
        //成功したらtrueを代入
        context.commit('setApiStatus', true)
        context.commit('setUser', response.data)
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }
      
      //通信に失敗した場合に error モジュールの setCode ミューテーションを commit するが、あるストアモジュールから別のモジュールのミューテーションを commit する場合は第三  引数に { root: true } を追加する必要がある。
      context.commit('error/setCode', response.status, { root: true })
    }).catch( error => {
      console.log(error.response);

      if(error.response.status === UNAUTHORIXED){
        //ログイン認証失敗
        context.commit('setApiStatus', false)
        context.commit('loading/clearLoading', null, { root: true } )
        context.commit('setLoginErrorMessages', error.response.data.message)
        return false
      }
      //それ以外のエラー
      context.commit('setApiStatus', false)
      context.commit('error/setCode', error.response.status, { root: true } )
      context.commit('loading/clearLoading', null, { root: true } )
      return false
    })
  },
    /**
   * ログアウト処理
   */
  async logout(context){
    context.commit('setApiStatus', false)
    context.commit('loading/setLoadingStatus', { loading: true }, { root: true } )
    context.commit('setUser', false)
    context.commit('loading/clearLoading', null, { root: true } )
    context.commit('setApiStatus', true)  //ユーザーデータをクリアしているので/loginに飛ばされる
  },
  /**
   * ログインユーザーチェック
   * @param {*} context 
   */
  async currentUser(context){
    //tokenが保持されている場合は認証
    context.commit('setApiStatus', null)
    context.commit('loading/setLoadingStatus', { loading: true }, { root: true } )
    //storeにtokenが保存されていない場合はそのままスルー
    if(context.getters.token === ''){
      context.commit('setUser', { user: null, token: null })
      context.commit('setApiStatus', true)
      context.commit('loading/clearLoading', null, { root: true } )
      return false
    }
    await Apiaxios.auth(context.getters.postUser).then(response => {
      if (response.status === OK) {
        context.commit('setApiStatus', true)
        context.commit('setUser', response.data)
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }
      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('error/setCode', response.status, { root: true })
      context.commit('loading/clearLoading', null, { root: true } )
    }).catch(function(error){
      console.log(error.response);

      context.commit('setUser', false)
      if(error.response.status === INTERNAL_SERVER_ERROR){
        // context.commit('setApiStatus', false)  //ユーザーデータをクリアしているので/loginに飛ばされる
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true } )
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }
      context.commit('error/setCode', error.response.status, { root: true } )
      // context.commit('setApiStatus', true)  //ユーザーデータをクリアしているので/loginに飛ばされる
      context.commit('loading/clearLoading', null, { root: true } )
      
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}